import { validateNumField, MAX_NUM_LENGTH } from '../../../utils';
export default {
    name: 'NumEditor',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            value$: this.value,
            MAX_NUM_LENGTH,
        };
    },
    computed: {
        validator() {
            return validateNumField(this.value$);
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.value$ = this.value;
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.focus();
            }
        });
    },
    methods: {
        onEnter() {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.blur();
            }
        },
        onFinishEdit() {
            this.$emit('endLabelingField');
            if (!this.validator.valid) {
                return;
            }
            this.$emit('updateFieldValue', this.value$);
        },
    },
};
